import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAtomValue } from "jotai";

import { personaAtom, type PersonaRole } from "@/store";

interface ProtectedRouteProps {
  children: ReactNode;
  requiredRoles?: PersonaRole[];
}

export function ProtectedRoute({
  children,
  requiredRoles,
}: ProtectedRouteProps) {
  const persona = useAtomValue(personaAtom);

  if (requiredRoles && requiredRoles.length > 0) {
    if (!requiredRoles.includes(persona.role)) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
